import { create } from "zustand";
import type { AuthStatus, User } from "@/types";

interface AuthState {
  status: AuthStatus;
  user: User | null;
  resolveAuth: () => void;
  login: (email: string) => Promise<void>;
  signup: (name: string, email: string) => Promise<void>;
}

// Mock auth store — simulates reading a stored session token on boot.
// Swap resolveAuth body for a real token check when the backend is wired.
export const useAuthStore = create<AuthState>((set, get) => ({
  status: "resolving",
  user: null,
  resolveAuth: () => {
    if (get().status !== "resolving") return;
    window.setTimeout(() => {
      set({ status: "unauthenticated", user: null });
    }, 650);
  },
  login: (email) =>
    new Promise((resolve) => {
      window.setTimeout(() => {
        set({
          status: "authenticated",
          user: { id: "u_mock_01", name: email.split("@")[0], email },
        });
        resolve();
      }, 900);
    }),
  signup: (name, email) =>
    new Promise((resolve) => {
      window.setTimeout(() => {
        set({ status: "authenticated", user: { id: "u_mock_02", name, email } });
        resolve();
      }, 1100);
    }),
}));
